import { type SetterOrUpdater, useRecoilState } from "recoil";

import { type Dimension } from "../models/dimension-funnel";
import { breakdownDimensionAtom } from "../state";

export const useBreakdownDimension = (): {
    breakdownDimension: Dimension;
    setBreakdownDimension: SetterOrUpdater<Dimension>;
} => {
    const [breakdownDimension, setBreakdownDimension] = useRecoilState(breakdownDimensionAtom);

    return { breakdownDimension, setBreakdownDimension };
};
